// extracted by mini-css-extract-plugin
export default {"stockWrapper":"MarketingStockWrapper_stockWrapper__UZdJA","spinner":"MarketingStockWrapper_spinner__67ogX"};